type Config = {
  socketURL: string;
};

const config: Config = {
  socketURL: 'adexio-api.braun-its.de',
};

export default config;
